const injectZIndex = theme => {
  const zIndex = {
    pageHeader: 900,
    drawer: 1100,
    appBar: 1200
  };
  Object.assign(theme.zIndex, zIndex);
  return theme;
};

export { injectZIndex };
